import React from 'react'
import cn from 'classnames'
import { Link, useLocation, useNavigate } from 'react-router-dom'

import useFetch from '../../hooks/useFetch'
import Menu from './MenuList'
import Image from '../ui/Image/Image'
import NpciIcon from '../ui/icons/NPCI'

import styles from './Footer.module.scss'
import { getImageUrl } from '../../utils'
import useIsMobile from '../../hooks/useIsMobile'

const Footer = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const isMobile = useIsMobile()
  const transferData = (resp) => resp.data
  const { data, loading } = useFetch('footer', transferData)

  const logoClickHandler = () => {
    if (pathname === '/') {
      window.scrollTo(0, 0)
    } else {
      navigate('/')
    }
  }

  const renderFooterMenus = () => {
    return (
      data?.site_information &&
      data?.site_information.map((menu) => (
        <div
          key={'site_information' + menu?.id}
          className={styles.footerSection}
        >
          <h2>{menu?.link?.label}</h2>
          <Menu menu={menu.menus} parentPath={menu?.link?.path} />
        </div>
      ))
    )
  }

  return (
    <footer className={styles.footer}>
      {loading ? (
        <></>
      ) : (
        <div className={styles.footerInnerContainer}>
          <div className={styles.footerContent}>
            <div className={styles.footerSection}>
              <button
                onClick={logoClickHandler}
                className="flex title-font font-medium items-center"
              >
                <NpciIcon
                  npciColor="#fff"
                  bottomTextColor="#fff"
                  className={cn(styles.iconContainer)}
                  ariaLabel={'NIPL Home'}
                />
              </button>
            </div>
            {isMobile ? (
              renderFooterMenus()
            ) : (
              <div className={styles.footerMapSection}>
                {renderFooterMenus()}
              </div>
            )}
          </div>
          <div className={styles.footerBottom}>
            <div className={styles.footerBottomFlex}>
              <div className={styles.footerLinks}>
                {data?.site_policies &&
                  data?.site_policies.map((sM) => (
                    <span key={'site_policies' + sM?.id}>
                      <Link to={sM.policy_link}>{sM.policy_title}</Link>
                    </span>
                  ))}
              </div>
              {data?.social_media && data?.social_media.length > 0 && (
                <div className={styles.footerSocial}>
                  {data?.social_media.map((m) => (
                    <Link
                      to={m.social_media_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      key={m?.id + m?.social_media_link}
                    >
                      <Image
                        src={getImageUrl(m?.socialmedia_image || {})}
                        alt={m?.social_media_icon?.alternativeText}
                      />
                    </Link>
                  ))}
                </div>
              )}
            </div>
            <div
              className={cn(styles.rightsContainer, styles.footerBottomFlex)}
            >
              <span>{data?.corporate_identity_number}</span>
              <span className={styles.copyright}>{data?.copyright_notice}</span>
            </div>
          </div>
        </div>
      )}
    </footer>
  )
}

export default Footer
